module.exports = __webpack_public_path__ + "img/loader.e9c962bb.gif";